(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ActividadesEvaluacion', ActividadesEvaluacion);

    ActividadesEvaluacion.$inject = ['$resource','DateUtils'];

    function ActividadesEvaluacion ($resource,DateUtils) {
        var resourceUrl =  'apo/actividades:id,:anio,:institucion,:modelo,:nivel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
            	url:'apo/actividades/:id',
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicio=DateUtils.convertDateTimeFromServer(data.inicio);
                        data.fin=DateUtils.convertDateTimeFromServer(data.fin);
                    }
                    
                    return data;
                }
            },
            'update': { 
            	url:'apo/actividades',
            	method:'PUT',
            	transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertDateTimeFromServer(copy.inicio);
                    copy.fin = DateUtils.convertLocalDateToServer(copy.fin);
                    data = angular.toJson(copy);
                    return data;
                }
            },
            'save': { 
            	url:'apo/actividades',
            	method:'POST' 
            }
        });
    }
})();
